/**
 * The coded refusals of the extras selection (packages-api HotelExtras.ExtraServicePriceSelection) with the website's own text (C21: the
 * English text is the key, its Russian line is in ru-RU.json) - QA doc docs features/website/hotel-details-services.md R-LX7 / error codes.
 * The server's own sentence names supplier codes and is English only; the agent reads ours, next to the Trace ID the dialog already shows.
 */
export const EXTRA_SERVICE_ERROR_TEXTS: Readonly<Record<string, string>> = {
  EXTRA_SERVICE_PRICE_NOT_OFFERED: 'This extra service price is not offered for the selected offer',
  EXTRA_SERVICE_MANDATORY_NOT_SELECTED: 'A mandatory extra service is not selected'
};

/** The translation key for an extras refusal code, or undefined for any other code. */
export const extraServiceErrorText = (code: string | null | undefined): string | undefined =>
  code ? EXTRA_SERVICE_ERROR_TEXTS[code] : undefined;
